export const BASE_URL = process.env.REACT_APP_API_KEY;
export const REPORT_URL = process.env.REACT_APP_REPORT_URL;

export const ENDPOINTS = {
  MANAGEURL: "/manage-account/manage-url",
  MANAGEPASWORD: "/manage-account/manage-password",
  MANAGEACCOUNTPROFILE: "/manage-account/manage-account-profile",
  MANAGEFREELINK: "/manage-account/manage-fast-link",
  MANAGEROICALCULATOR: "/manage-account/roi-calculator",
  MANAGETERMS: "/manage-account/marketing-resources",
  LOGINURL: "/manage-account/login",
  NMVTISLOGINURL: "/manage-account/nmvtis-login",
  TOKENEXTRACT: "/manage-account/token-extract",
  FULLREPORT: "/report/full-report",
  SUMMARYREPORT: "/report/summary-report",
  SCANREPORT: "/report/scan-report",
  ACCIDENTREPORT: "/report/accident-report",
  NMVTISREPORT: "/report/nmvtis-report",
  GETDEALERS: "dealers/details",
  GETDEALERGROUPS: "dealers/group-details",
  CONTACTUS: "/contact-us",
  COXCONTACTUS: "/coxContactUs",
  CORRECTIONREQUEST: "/correctionRequest",
  UPLOADLIFTTOOL: "/upload-lift-tool-file",
  REPORTUSAGEDASHBOARD: "/manage-account/member-usage",
  PRINTPDF: "/printReport.do",
  EMAILREPORT: "/email-report",
  BILLINGUSAGE: "manage-account/bill-cycle-usage",
  REFERFRIEND: "/refer-friend",
  POSORDER: "/pos-order",
  REQUESTPASSWORD: "/request-password",
  SUPPORT_REQUEST: "/support-request",
  COX_SERVICE_DATA_REQUEST: "/service-data"
};
